import React from 'react';
import { ComponentTypeIcon } from '../InputMessage/ComponentPicker';
import {
  formatComponentChipLabel,
  getComponentChipLabel,
  resolveComponentTypeFromInfo,
  type ChatComponentItem,
  type ComponentType,
} from '../../../../types/chat-component';
import type { ComponentInfoPayload } from '../../../../types/chat-message';

type ComponentInfoChipProps = {
  text: string;
  componentType?: ComponentType | null;
  className?: string;
};

export const ComponentInfoChip: React.FC<ComponentInfoChipProps> = ({
  text,
  componentType,
  className = '',
}) => {
  if (!text?.trim()) return null;

  return (
    <div
      className={`inline-flex h-9 w-fit max-w-[250px] items-center gap-2 overflow-hidden rounded-full p-2 text-[13px] font-normal leading-[18px] text-[#242428] opacity-100 ${className}`}
      style={{
        background:
          'linear-gradient(127.37deg, #F3F3F3 -9.52%, #F8F8F9 47.95%, #F3F3F3 105.42%)',
      }}
    >
      {componentType ? (
        <span className="inline-flex h-5 w-5 shrink-0 items-center justify-center text-[#242428]">
          <ComponentTypeIcon type={componentType} className="h-4 w-4" />
        </span>
      ) : null}
      <span className="min-w-0 truncate font-normal">{text}</span>
    </div>
  );
};

export const ComponentInfoChipFromAttached: React.FC<{
  item: ChatComponentItem;
  className?: string;
}> = ({ item, className }) => (
  <ComponentInfoChip
    text={getComponentChipLabel(item)}
    componentType={item.type}
    className={className}
  />
);

export const ComponentInfoChipFromPayload: React.FC<{
  payload: ComponentInfoPayload;
  className?: string;
}> = ({ payload, className }) => {
  const rawText = payload?.text?.trim() || '';
  if (!rawText) return null;

  const attachmentType =
    payload.data?.attachmentType ??
    payload.data?.attachment_type ??
    payload.attachmentType ??
    payload.attachment_type;
  const componentType = resolveComponentTypeFromInfo(attachmentType, rawText);
  const text = formatComponentChipLabel(componentType, rawText);

  return (
    <ComponentInfoChip
      text={text}
      componentType={componentType}
      className={className}
    />
  );
};

export default ComponentInfoChip;
